import { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import { IReportSMS, IResponseDataTable } from '../../interfaces/apis';
import dayjs from 'dayjs';
import reportApis, { SMSReportParams } from '../../../../services/reportApis';

const DEFAULT_PARAMS: SMSReportParams = {
  page: 1,
  size: 10,
  shopId: undefined,
  startDate: dayjs().subtract(7, 'day').startOf('day').format('MM-DD-YYYY'),
  endDate: dayjs().endOf('day').format('MM-DD-YYYY'),
};

const useGetReportSMS = (isLazy = false) => {
  const [params, setParams] = useState<SMSReportParams>(DEFAULT_PARAMS);

  const [data, setData] = useState<IResponseDataTable<IReportSMS>>();
  const [loading, setLoading] = useState(false);

  const fetchData = async (paramsSubmit: SMSReportParams) => {
    setLoading(true);
    try {
      const response: AxiosResponse<{ data: IResponseDataTable<IReportSMS> }> = await reportApis.getSMSReport({
        ...paramsSubmit,
        shopId: paramsSubmit.shopId ? paramsSubmit.shopId : undefined,
        startDate: dayjs(paramsSubmit.startDate).format('MM-DD-YYYY'),
        endDate: dayjs(paramsSubmit.endDate).format('MM-DD-YYYY'),
      });

      setData(response.data.data);
    } catch (error) {
      setData(undefined);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isLazy) {
      fetchData(params);
    }
  }, [params, isLazy]);

  return {
    data,
    loading,
    params,
    setParams,
  };
};

export default useGetReportSMS;
